import { useEffect, useState } from "react";
import appConfig from "../appConfig";


export const useGoogleMaps = (active: boolean) => {
  const [ready, setReady] = useState(!!window.google?.maps);

  useEffect(() => {
    if (!active || ready) return;
    if (window.google?.maps) {
      setReady(true);
      return;
    }
    if (!appConfig.GOOGLE_MAPS_API_KEY) return;
    if (document.querySelector('script[src*="maps.googleapis.com"]')) return;

    const cb = "__initSelectionMap__";
    (window as any)[cb] = () => setReady(true);
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${appConfig.GOOGLE_MAPS_API_KEY}&callback=${cb}`;
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
    return () => {
      delete (window as any)[cb];
    };
  }, [active, ready]);

  return ready;
};